import selectCard from "../view/Resource/img/icon_card_2.png";
import card from "../view/Resource/img/icon_card_1.png";
import selectList from "../view/Resource/img/icon_list_2.png";
import list from "../view/Resource/img/icon_list .png";
import selectTimeAxis from "../view/Resource/img/time axis_1.png";
import timeAxis from "../view/Resource/img/timeaxis.png";

export const modeIcon = [{
    key: "selectCard",
    src: selectCard
}, {
    key: "card",
    src: card
},
    {
        key: "selectList",
        src: selectList
    }, {
        key: "list",
        src: list
    }, {
        key: "selectTimeAxis",
        src: selectTimeAxis
    }, {
        key: "timeAxis",
        src: timeAxis
    }
]
